import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/others/compliance-2.png")